import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import './checkbox.scss';

@Component({
             template: `
<span>
  <span ref="ripples"></span>
  <label class="checkbox-wrapper">
    <span class="checkbox-floating">
      <input class="checkbox" @click="addRipple" :checked="value" @change="onChange" type="checkbox" :name="name"/>
      <span></span>
    </span>
    <slot></slot>
  </label>
</span>
           `})
export class CheckboxComponent extends Vue {
  @Prop()
  name: string;

  @Prop()
  value: boolean;

  ripples = [];

  addRipple() {
    const ripple = document.createElement('div');
    ripple.className = 'ripple';
    if (!this.value) {
      ripple.className += ' red';
    }
    (<HTMLElement>this.$refs.ripples).appendChild(ripple);
    setTimeout(() => { try { (<HTMLElement>this.$refs.ripples).removeChild(ripple) } catch(e) {}}, 1000);
  }

  onChange(event) {
    this.$emit('input', event.target.checked)
  }
}

Vue.component('checkbox', CheckboxComponent);



// WEBPACK FOOTER //
// ./src/components/checkbox/checkbox.ts